/**
 * The PHP gateway answers a call from a caller with no live session with
 * exactly { success: false, message: 'Not authenticated.' } (trailing period).
 * Do not confuse it with Authentication.getStatus's normal guest answer,
 * 'Not authenticated' without the period, which must not match.
 *
 * CommonJS so the node-backend logic tests can require it.
 */

function isRefusal(item) {
    return !!item && typeof item === 'object' && item.success === false && item.message === 'Not authenticated.';
}

// res is one response object, or an array of them for a batch.
function isSessionRefusal(res) {
    return Array.isArray(res) ? res.some(isRefusal) : isRefusal(res);
}

module.exports = {
    isSessionRefusal: isSessionRefusal,
};
